import { Loader2, RefreshCw, Sparkles } from 'lucide-react';
import Button from '../../ui/Button';
import { formatTimestamp, statusTone } from './semantics';

interface SummaryHeroProps {
  companyName: string;
  combinedSummary?: string;
  status?: string;
  fetchedAt?: number | null;
  isRefreshing: boolean;
  onRefresh: () => void;
}

export function SummaryHero({
  companyName,
  combinedSummary,
  status,
  fetchedAt,
  isRefreshing,
  onRefresh,
}: SummaryHeroProps) {
  const tone = statusTone(status);

  return (
    <div className="rounded-xl border border-neutral-200 bg-white p-5">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0 flex-1">

          {/* Company name */}
          <h2 className="text-lg font-bold text-neutral-900 leading-tight">{companyName}</h2>

          {/* Status pill */}
          {status && (
            <span
              className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold mt-1.5 ${tone.pill}`}
            >
              {status.charAt(0).toUpperCase() + status.slice(1)} Analysis
            </span>
          )}

          {/* Combined summary */}
          {combinedSummary && (
            <p className="text-sm text-neutral-700 leading-relaxed mt-3">{combinedSummary}</p>
          )}

          {/* Timestamp */}
          {fetchedAt && (
            <p className="text-[11px] text-neutral-400 mt-2">
              Last analyzed: {formatTimestamp(fetchedAt)}
            </p>
          )}
        </div>

        {/* Refresh action */}
        <Button
          variant="outline"
          size="sm"
          onClick={onRefresh}
          disabled={isRefreshing}
          aria-label="Re-analyze documents"
        >
          {isRefreshing ? (
            <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
          ) : (
            <RefreshCw className="h-4 w-4" aria-hidden="true" />
          )}
          Refresh Analysis
        </Button>
      </div>
    </div>
  );
}
